<template>
  <v-btn
    x-large
    text        
    color="teal"
    class="font-weight-bold"
    @click="addPedido()"    
    block    
    ><v-icon left>mdi-plus</v-icon>ADICIONAR PEDIDO</v-btn
  >
</template>

<script>
export default {
  methods: {
    addPedido() {
      this.$router.push({ path: `/formacao-carga/${this.$route.params.id}/selecionar-pedido/0` });
    },
  },
};
</script>

<style>
</style>